import React from 'react';

// Sub-hour timeframes are intentionally excluded: Yahoo only serves 1m-granularity
// data for the trailing ~8 days, which makes 1m/5m/15m/30m unreliable. 1H is the floor.
const timeframes = ['1H', '4H', '1D', '1W'];

const TimeframeControls = ({ selectedTimeframe, onSelectTimeframe }) => {
  return (
    <div className="flex flex-wrap items-center gap-1 bg-white p-1 rounded-md shadow-sm border border-gray-200">
      {timeframes.map(tf => (
        <button
          key={tf}
          onClick={() => onSelectTimeframe(tf)}
          className={`px-2 py-1 text-[11px] sm:px-3 sm:text-xs font-medium rounded transition-colors duration-150 ${
            selectedTimeframe === tf
              ? 'bg-blue-600 text-white shadow'
              : 'bg-white text-gray-700 hover:bg-gray-100'
          }`}
        >
          {tf}
        </button>
      ))}
    </div>
  );
};

export default TimeframeControls;
